module.exports = {
  title: 'Grid Visualizer with React Native Skia 🔢',
  author: 'Enzo Manuel Mangano',
  date: '2024-06-05',
  slug: 'grid-visualizer',
  tags: ['skia'],
};
